import { combineReducers } from "redux";
import appReducer from "./appReducer";
import userReducer from "./userReducer";
import surveyReducer from "./surveyReducer";

const reducers = combineReducers({ app: appReducer, user: userReducer, survey: surveyReducer });

export default reducers;
